import react, { useEffect, useState } from "react";
import "./App.css";
import Layout from "./Component/Layout/Layout";
import { useHistory } from "react-router-dom";
import { Route, Switch, Redirect } from "react-router-dom";
import Login from "./Component/LOGIN/Login";
import auth from "./service";
import axios from "axios";
import { config } from "./../src/confi";

function App() {
  const [isAuthenticated, setAuthenticate] = useState(false);
  const history = useHistory();

  function token_verify(token) {
    return new Promise((resolve, reject) => {
      let reqbody = JSON.stringify({
        fn: "common_fun",
        an: "tk_ve",
        payload: { token: token }
      });
  
      axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    });
  }


  useEffect(() => {
    const isAuth = auth.getAuth();
  
    if (isAuth) {
      token_verify(isAuth)
        .then((res) => {
          if (res.status === 200 && res.data.status === 0) {
            setAuthenticate(true);
          } else {
            localStorage.removeItem("token-2");
              history.push("/login");
          }
        })
        .catch((err) => {
          console.log(err);
          localStorage.removeItem("token-2");

        });
    } else {
      setAuthenticate(false);
    }
  }, []);






  const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        auth.getAuth() ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );





  return (

    <div className="App">
      <Switch>
        <Route path="/" exact={true}>
          {isAuthenticated ? (
            <Redirect to="/admin" />
          ) : (
            <Redirect to="/login" />
          )}
        </Route>

        <Route path="/login" component={Login} />
        {/* <Route path="/admin" component={Layout} /> */}

        {/* <Route path="/admin/new-entry" component={New_entry} /> */}

        <PrivateRoute path="/admin" component={Layout} />
      </Switch>
    </div>

  );
}

export default App;
